import config from "@config";
import apiService from "@utils/js/ApiService";
import { redirectToLogin } from "@utils/js/utilities";

function Logout() {
  apiService(config.GARTNER_URL)
    .post(
      config.API_PATH.LOGOUT,
      {},
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          withCredentials: true,
        },
      }
    )
    .catch(() => {})
    .finally(() => {
      redirectToLogin();
    });
}

export default Logout;
